import { createAppKit } from '@reown/appkit/react'

import { WagmiProvider } from 'wagmi'
import { bsc, bscTestnet } from '@reown/appkit/networks'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { network, ReOwnProjectId, websiteURL } from '../config'

// Simple query client without custom options
const queryClient = new QueryClient()

// Get project metadata
const projectId = ReOwnProjectId
const metadata = {
    name: 'SWSS Draw',
    description: 'SWSS Draw Platform',
    url: websiteURL,
    icons: ['https://avatars.githubusercontent.com/u/179229932'],
    verifyUrl: websiteURL, // Add verifyUrl for better mobile wallet verification
}

// Determine network based on environment
const envNetwork = network === "mainnet" ? bsc : bscTestnet
const networks = [envNetwork]

// Create Wagmi Adapter with minimal configuration
const wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
    ssr: true // Enable SSR for better mobile support
})

// Initialize AppKit with minimal features
createAppKit({
    adapters: [wagmiAdapter],
    networks,
    projectId,
    metadata,
    features: {
        analytics: false,
        email: false,
        socials: [],
    }
})

export function ContextProvider({ children }) {
    return (
        <WagmiProvider config={wagmiAdapter?.wagmiConfig}>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </WagmiProvider>
    )
}